import { ContainerModule } from '@yandex-int/k-common/typings';
import cx from 'classnames';
import { Link, SimpleCallback } from 'platform-components';
import React from 'react';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import './course-container__module-card-preview.scss';

interface Props {
    className?: string;
    containerModule: ContainerModule;
    onClick?: SimpleCallback;
    link?: React.ComponentProps<typeof Link>['to'];
}

export const CourseContainerModuleCardPreview = ({ className, containerModule, link, onClick }: Props) => {
    const { color: moduleColor } = containerModule.module;

    const hatStyle = {
        backgroundColor: moduleColor ? moduleColor : undefined,
    };

    if (!link) {
        return (
            <div className={cx('course-container__module-card-preview', className)} {...accessibleClick(onClick)}>
                <div className="course-container__module-card-preview-hat" style={hatStyle} />
            </div>
        );
    }

    return (
        <Link className={cx('course-container__module-card-preview', className)} isRouter onClick={onClick} to={link}>
            <div className="course-container__module-card-preview-hat" style={hatStyle} />
        </Link>
    );
};
